module.exports = __webpack_public_path__ + "img/complete-background-image.f66a1b74.svg";